import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';

import { isEmptyObject, getOwner, capitalize, uuidv4, getObjectWithJsonArrayFilter, validateIsfilled, validateOnlyNumber, formatOnlyNumberInput, composeValidators } from '../../libraries/utils';

import transactionsActions from '../../context/purchases/actions';
import prescriptionsActions from '../../context/prescriptions/actions';
import usersActions from '../../context/users/actions';
import locationsActions from '../../context/locations/actions';
import messageActions from '../../context/messages/actions';

import LayoutSmall from '../../components/layout/LayoutSmall';
import TextareaInput from '../../components/forms/TextareaInput';
import Button from '../../components/commons/Button';

import PharmacyCard from '../../components/customs/PharmacyCard';
import Icon from '../../libraries/icons';
import MedicamentCartElement from '../../components/customs/MedicamentCartElement';
import SelectInput from '../../components/forms/SelectInput';
import TextInput from '../../components/forms/TextInput';
import ButtonIcon from '../../components/commons/ButtonIcon';

import MPCardData from  '../../components/payments/MPCardData';

import {initMercadoPago, Payment, createCardToken} from '@mercadopago/sdk-react'
initMercadoPago(config.MP_PUBLIC_KEY, {
  locale: 'es-AR'
});


class PurchaseReview extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      prescriptions: [],
      pharmacy: null,
      medicaments: [],
      prescription_medicaments: [],
      patient: null,
      locations: [],
      last_uploaded_location: null,
      delivery: null,
      customization: {
        paymentMethods: {
          creditCard: 'all',
          debitCard: 'all',
          //mercadoPago: 'all',
          minInstallments: 1,
          maxInstallments: 1,
        },
      }
    }
  }
  
  componentDidMount() {
    if (isEmptyObject(this.props.location.state)) { 
      history.push(config.ROUTES.HOME);
    } else {
      //add presciptions list to state, despues ver como separar los meds
      let { pharmacy, prescriptions, medicaments } = this.props.location.state;
      if(!medicaments){
        medicaments = []
      }
      if(!prescriptions){
        prescriptions = []
      }
      
      this.setState({ pharmacy, prescriptions, medicaments } );
      this.getMedicamentsFromPrescriptions(prescriptions)
      this.getUser()
      this.getLocations()

      console.log("STATE", pharmacy, prescriptions, medicaments)
    }
  }

  getUser = async () => {
    console.log('GETTING USER');
    await this.props.onGetUser({ id: this.props.auth.user.id });
    console.log('AFTER GET');
    const error = this.props.user.error;
    if (error) {
      notify(this.t(error.message));
    } else {
      this.setState({ patient: this.props.user.item });
    }
  }

  getMedicamentsFromPrescriptions = (prescriptions) => {
    let prescription_medicaments = []
    prescriptions.forEach(prescription => {
      if(prescription.prescriptions_lines){
        prescription.prescriptions_lines.forEach(line => {
          if(prescription_medicaments.some(m => m.target_id === line.target_id)){
            prescription_medicaments = prescription_medicaments.map(m => {
              if(m.target_id === line.target_id){
                m.quantity += line.quantity
              }
              return m
            })
          } else {
            const l = {...line}
            prescription_medicaments = [...prescription_medicaments, l]
          }
        })
      }
    })
    
    this.setState({ prescription_medicaments })
  }

  gotoSuccess = (id) => {
    history.push({
      pathname: config.ROUTES.SUCCESS,
      state: {
        title: "Pedido realizado con éxito",
        button: {
          text: "Ver pedido",
          route: config.ROUTES.CHAT.replace(":root_id",id),
        },
        button2: {
          text: "Home",
          route: config.ROUTES.HOME,
        }
      }
    });
  } 


  onSubmit = async (values) => {
    const {pharmacy, patient, prescriptions, medicaments, prescription_medicaments, delivery} = this.state;
    const location = this.state.locations.find(l => l.id === values.address)
    const payload = {
      type: config.TRANSACTIONS.PURCHASE.TYPE,
      sub_type: config.TRANSACTIONS.PURCHASE.SUB_TYPE.PHARMACY,
      status: config.TRANSACTIONS.PURCHASE.STATUS.OPEN,
      source: pharmacy.id, //id de business
      target: getOwner(this.props.auth.user),
      owner: config.OWNER.SYSTEM,
      json_data: {
        pharmacy,
        prescriptions: prescriptions,
        prescription_medicaments: prescription_medicaments,
        medicaments,
        comments: values.comments,
        patient,
        location: delivery ? location : null,
        delivery,
      },
    }

    console.log(payload)
    
    const payload_filter_arr = 
    [
      "type","sub_type","status","source","target","owner","clinicalHistory","time",
      "prescriptions","prescription_medicaments","medicaments","comments", "location",
      {pharmacy: ["id","name","owner","email","address","logo_picture", "user_id",]},
      {patient: ["id","accounts","name","first_name","last_name","profile_image","birth_date","gender","identification","identification_type","insurance","insurance_number"]},    
      //{professional: ["id","accounts","first_name","last_name","profile_image","specialty"]},
    ]
    


    const filtered_payload = getObjectWithJsonArrayFilter(payload,payload_filter_arr)
    filtered_payload.json_data.pharmacy.address = filtered_payload.json_data.pharmacy.address?.direccion ? filtered_payload.json_data.pharmacy.address?.direccion : "Sin dirección"

    if(!(pharmacy.user_id ? pharmacy.user_id : pharmacy.json_data?.user_id)){
      console.log("error", pharmacy)
      return
    }

    //if(true){
    //  const response = await createCardToken({
    //    cardholderName: 'APRO',
    //    identificationType: '<BUYER_IDENTIFICATION_TYPE>',
    //    identificationNumber: '<BUYER_IDENTIFICATION_NUMBER>',
    //  });        
    //}
    //return

    await this.props.onSave(filtered_payload)
    const trx = this.props.transactions;
    if (trx.error) {
      notify(this.t(trx.error.message));
    } else {
      // Create conversation
      const object = {
        body: "__PEDIDO__",
        target: pharmacy.user_id ? pharmacy.user_id : pharmacy.json_data?.user_id, //fixme: ARREGLAR TEMA GET OWNER
        source: this.props.auth.user.id, //fixme: ARREGLAR TEMA GET OWNER
        parent: 'root',
        type: 'message',
        related_to: trx.item.id,
        json_data: {
          deleted_chat_for_source: 0,
          deleted_for_source: 0,
          deleted_chat_for_target: 0,
          unread_messages_for_target: 1,
          unread_messages_for_source: 0
        }
      }
      await this.props.onSaveMessage(object)
      const message = this.props.message
      if (message.error) {
        notify(this.t(message.message));
      }
      const root_id = message.item.id;
      if(values.comments && values.comments !== ""){
        const object_ = {
          body: values.comments,
          target: pharmacy.user_id ? pharmacy.user_id : pharmacy.json_data?.user_id, //fixme: ARREGLAR TEMA GET OWNER
          source: this.props.auth.user.id, //fixme: ARREGLAR TEMA GET OWNER
          parent: message.item.id,
          type: 'message',
          related_to: trx.item.id,
          json_data: {
            deleted_chat_for_source: 0,
            deleted_for_source: 0,
            deleted_chat_for_target: 0,
            unread_messages_for_target: 1,
            unread_messages_for_source: 0
          }
        }
        await this.props.onSaveMessage(object_)
        const message_ = this.props.message
        if (message_.error) {
          notify(this.t(message_.message));
        }
      }

      if(payload.json_data.prescriptions.length === 0){
        //if(payload.json_data.delivery){
        //  this.setState({payment: true, trx: this.props.transactions.item})
        //  return
        //}

        this.gotoSuccess(root_id)
      } 
      else {
        const ids = payload.json_data.prescriptions.map(p => p.id)
        await this.props.onUpdateManyPrescriptions({id:ids, status:config.PRESCRIPTIONS.STATUS.INACTIVE})
        const prescriptions = this.props.prescriptions;
        if (prescriptions.error) {
          notify(this.t(prescriptions.message));
        } else {
          //if(payload.json_data.delivery){
          //  this.setState({payment: true, trx: this.props.transactions.item})
          //  return
          //}
  
          this.gotoSuccess(root_id)
        }
      }
    }
  }

  paymentNext = async (values) => {
    let payload = { ...values, ...values.formData }
    payload.card_token = payload.token
    delete payload.token
    payload = {
      ...payload,
      trx_id: this.state.trx.id,
      pharmacy_id: this.state.trx.json_data.pharmacy.user_id,
    }

    console.log("payload", payload)
    await this.props.onPay(payload)
    const trx = this.props.transactions;
    if (trx.error) {
      notify(this.t(trx.error.message));
    } else {
      this.gotoSuccess()
    }
  }

  getLocations = async () => {
    await this.props.onGetAllLocations({ owner: getOwner(this.props.auth.user)});
    const { locations } = this.props;
    if (locations.error) {
      notify(this.t(locations.error.message));
    } else {
      console.log("LOCATIONS", locations.items)
      this.setState({ locations: locations.items });
    }    
  }

  onSubmitLocation = async (values) => {
    console.log(values)
    const data = { name: values.location_name, owner: getOwner(this.props.auth.user) };
    await this.props.onSaveLocation(data)
    const { location_address } = this.props;
    if (location_address.error) { 
      notify(this.t(location_address.error.message));
    } else {
      console.log('SAVED LOCATION', location_address.item);
      this.setState({last_uploaded_location: location_address.item.id})
      this.getLocations()
      this.closeLocationModal()
      
    }
    
  }

  openLocationModal = (values) => {
    //console.log("__values", values)
    this.setState({openLocationModal: true})
  }

  closeLocationModal = () => {
    this.setState({openLocationModal: false})
  }

  setDelivery = (delivery) => {
    this.setState({delivery})
  }

  gotoBack = () => {
    const {pharmacy, prescriptions, medicaments} = this.state;    
    history.push(config.ROUTES.PURCHASES.CART, {pharmacy, prescriptions, medicaments});
  }  

  render(){
    const {pharmacy, prescriptions, medicaments, prescription_medicaments, locations, delivery} = this.state;
    console.log("prescriptions", prescriptions)
    const addreses = locations.map(c => {return {value: c.id, label: c.name}})
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    const onlynumber = value => (validateOnlyNumber(value) ? undefined : this.t("El documento solo debe llevar digitos"))
    const dnilength = value => (value.length >= 7 && value.length <= 8 ? undefined : this.t("El documento debe tener 7 u 8 numeros"))

    const dni_types = config.OPTIONS.SINGUP.IDENTIFICATION.TYPES.map((o) => { return { value: o, label: this.t(o) } });

    console.log("pharmacy_", pharmacy)
    console.log("STATE", this.state.payment)
    return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: this.t("Enviar receta"),
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          {!this.state.payment && <Form onSubmit={this.onSubmit} initialValues={{address: this.state.last_uploaded_location}}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <div className="mb-10">
                <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                  { pharmacy && <PharmacyCard pharmacy={pharmacy}/>}
                  <h2 className="mb-4 mt-5">{this.t("Pedido")}</h2>
                  { prescriptions && prescription_medicaments.map((line, index) =>{ 
                    const medicament = line.json_data.medicament
                    return(
                      <MedicamentCartElement
                        key={index} className="border-b py-2"
                        medicament={medicament}
                        prescription={true}
                      />
                    )
                  })}
                  { medicaments && medicaments.map((medicament, index) =>{ 
                    return(
                      <MedicamentCartElement
                        key={index}
                        className="border-b py-2"
                        medicament={medicament}
                        editable={false}
                      />
                    )
                  })}
                    <div className="btn-group my-4">
                      <Button
                        className={"btn-secondary " + (this.state.delivery === false ? "btn-active" : "")}
                        title={this.t("Retirar")}
                        onClick={() => this.setDelivery(false)}
                      />
                      <Button
                        className={"btn-secondary " + (this.state.delivery === true ? "btn-active" : "")}
                        title={this.t("Enviar")}
                        onClick={() => this.setDelivery(true)}
                      />
                    </div>                 
                    {this.state.delivery && <>
                      <div className="flex">
                        <Field 
                          className="w-full mr-3"
                          name="address" 
                          component={SelectInput} 
                          placeholder={this.t("Seleccioná dirección")}
                          options={addreses} 
                          label={this.t("Direccion")}
                          empty={this.t("Seleccione")}
                          validate={required}
                        />
                        <ButtonIcon
                          className="w-6 h-6"
                          buttonClassName="btn-circle btn-sm mt-11"
                          icon="plus"
                          htmlFor="location-modal" 
                          onClick={() => {this.openLocationModal(values)}}
                        />
                      </div>


                      
                      {/*
                      <CardPayment
                        initialization={{ amount: 100, payer: {
                              //email: 'test_user_292224969@testuser.com',
                              //identification: {
                              //  type: "DNI",
                              //  number: "12345678"
                              //}
                            },
                          }}
                        //customization={this.state.customization}
                        //onSubmit={this.onSubmitBrick}
                        />*/}
                        
                        {/*<div className="flex">
                          <div className="w-1/3 mr-3">
                            <Field name="identification_type" component={SelectInput} placeholder={this.t("Tipo")} label={this.t("Tipo de Doc.")} validate={required}
                              options={dni_types}
                              empty={this.t("Seleccione")}
                            />
                          </div>
                          <div className="w-2/3">
                            <Field name="identification" parse={v => formatOnlyNumberInput(v, 8)} component={TextInput} placeholder={this.t("Nro de Documento")} label={this.t("Nro de Documento")} validate={composeValidators(required, onlynumber, dnilength)} />
                          </div>
                      </div>
                      

                      <div className="divider"></div>*/}
                       



                      <input type="checkbox" id="location-modal" className="modal-toggle" checked={this.state.openLocationModal} onChange={()=>{}}/> 
                      <div className="modal">
                        <div className="modal-box bg-base-200">
                          <Form 
                            initialValues={{}}
                            onSubmit={this.onSubmitLocation}
                          >
                            {({ handleSubmit, form, submitting, pristine, values }) => (
                              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                                  <Field 
                                    name="location_name" 
                                    component={TextInput} 
                                    placeholder={this.t("Ej 'Mate de Luna 2356'")}
                                    label={this.t("Dirección consultorio")}
                                  />
                                  <div className="flex gap-3">
                                    <div className="modal-action flex-1 block">
                                      <label className="btn btn-ghost w-full" onClick={this.closeLocationModal}>Cerrar</label> 
                                    </div>
                                    <div className="modal-action flex-1 block">
                                      <label className="btn btn-primary w-full" onClick={handleSubmit}>Agregar</label> 
                                    </div>
                                  </div>
                              </form>
                            )}
                          </Form>
                        </div>
                      </div>
                    </>}
                  <div className="w-full mb-3 md:mb-0 mt-10">
                    <Field 
                      name="comments" 
                      component={TextareaInput} 
                      label={this.t("Comments")}
                      labelClassName="block uppercase text-gray-700 text-xs font-bold mb-2"
                      //initialValue={"Sin Observaciones"}
                    />
                  </div>
                </form>
                <Button
                  className="btn-primary btn-block"
                  title={"Confirmar Pedido"}
                  onClick={handleSubmit}
                  disabled={submitting || (delivery === null)}
                />
              </div>
            )}
          </Form>}
          
          {/*this.state.payment && <MPCardData paymentNext={this.paymentNext}/>*/}
          {this.state.payment && <> <Payment
                initialization={{
                  amount: 1000,
                  //preferenceId: this.state.preference_id,
                }}
                customization={this.state.customization}
                
            onSubmit={this.paymentNext}
            /> 

            <div className="divider"></div>
            <Button
                  className="btn-primary btn-block"
                  title={"Pagar en Mercadopago"}
                  onClick={async () => {
                    await this.props.onPreference({
                      trx_id: this.state.trx.id,
                      pharmacy_id: this.state.trx.json_data.pharmacy.user_id
                    });

                    console.log("this.props.transactions", this.props.transactions.item?.preference?.init_point)

                    if(this.props.transactions.item?.preference?.init_point){
                      window.open(this.props.transactions.item?.preference?.init_point, "_self")
                      return
                    }
                    
                  }}
                  disabled={false}
                />
              <></>
            </>}
        </section> 
       
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    transactions: state.purchases.current,
    prescriptions: state.prescriptions.list,
    user: state.users.current,
    locations: state.locations.list,
    location_address: state.locations.current,
    message: state.messages.current
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSave: (params) => dispatch(transactionsActions.saveOrUpdate(params)),
    onUpdateManyPrescriptions: (params) => dispatch(prescriptionsActions.updateMany(params)),
    onGetUser: (params) => dispatch(usersActions.get(params)),
    onSaveLocation: (params) => dispatch(locationsActions.saveOrUpdate(params)),
    onGetAllLocations: (params) => dispatch(locationsActions.getAll(params)),
    onSaveMessage: (params) => dispatch(messageActions.saveOrUpdate(params)),
    onPay: (params) => dispatch(transactionsActions.pay(params)),
    onPreference: (params) => dispatch(transactionsActions.preference(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PurchaseReview));

